<div class="center-xy" [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
    *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="time-limit-control">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <zone-icon [name]="zones.selectedZone.description.styleIcon" [size]="45"></zone-icon>
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ zones.getZoneName(zones.selectedZone) }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__control text-align-center">
                <p class="zone-control__control-title font-22 font-bold bg-settings bg-settings--zone">
                    {{ subtitle(1661) }}
                </p>
                <div class="control__range double">
                    <p class="control__double-title color-basic font-16 font-bold">
                        {{ subtitle(283) }}
                    </p>
                    <div class="control__value font-55 color-basic">
                        {{ zones.time.hour }}
                    </div>
                    <input class="control__input-range cursor-pointer"
                        (input)="zones.changeHourMinut('hour',0)"
                        (ngModelChange)="zones.onTimeChange('hour', $event)"
                        data-testid="hour-slider"
                        type="range"
                        [(ngModel)]="zones.time.hour"
                        min="0" max="24" step="1" />
                    <div class="control__remove cursor-pointer">
                        <hold-wrapper (onAction)="zones.changeHourMinut('hour',-1)">
                            <img ngSrc="/assets/img/icons/minus.svg"
                                 data-testid="minus-hour-icon"
                                 width="40" height="40" alt="" />
                        </hold-wrapper>
                    </div>
                    <div class="control__add cursor-pointer">
                        <hold-wrapper (onAction)="zones.changeHourMinut('hour',1)">
                            <img ngSrc="/assets/img/icons/plus.svg"
                                 data-testid="plus-hour-icon"
                                 width="40" height="40" alt="" />
                        </hold-wrapper>
                    </div>
                </div>

                <div class="control__range double">
                    <p class="control__double-title color-basic font-16 font-bold">
                        {{ subtitle(414) }}
                    </p>
                    <div class="control__value font-55 color-basic">
                        {{ zones.time.minute }}
                    </div>
                    <input class="control__input-range cursor-pointer"
                        (input)="zones.changeHourMinut('minute',0)"
                        (ngModelChange)="zones.onTimeChange('minute', $event)"
                        data-testid="minute-slider"
                        type="range"
                        [(ngModel)]="zones.time.minute"
                        min="0" [max]="zones.time.hour === 24 ? 0 : 59" step="1" />
                    <div class="control__remove cursor-pointer">
                        <hold-wrapper (onAction)="zones.changeHourMinut('minute',-1)">
                            <img ngSrc="/assets/img/icons/minus.svg"
                                 data-testid="minus-minute-icon"
                                 width="40" height="40" alt="" />
                        </hold-wrapper>
                    </div>
                    <div class="control__add cursor-pointer">
                        <hold-wrapper (onAction)="zones.changeHourMinut('minute',1)">
                            <img ngSrc="/assets/img/icons/plus.svg"
                                 data-testid="plus-minute-icon"
                                 width="40" height="40" alt="" />
                        </hold-wrapper>
                    </div>
                </div>
            </div>

            <div class="control__group-btn">
                <button class="control__button bg-default bg-default__button"
                    (click)="zones.goBack()">
                    <img class="control__button-img"
                        data-testid="back-button"
                        ngSrc="/assets/img/zone_icons/back.svg"
                        width="40" height="40" alt="" />
                </button>
                <button class="control__button bg-ok bg-ok--accept"
                    [ngClass]="{ 'not-allowed opacity-03': disableButton()}"
                    [disabled]="disableButton()"
                    (click)="zones.returnValue('timeLimit')">
                    <img class="control__button-img"
                         data-testid="send-button"
                         ngSrc="/assets/img/icons/ok.svg"
                         width="40" height="40" alt="" />
                </button>
            </div>
        </div>
    </div>
</div>
